<div class="content">
    <div class="section">
      <div class="header">
        <span class="mat-title">Testes</span>
        <div class="controls">
          <button mat-raised-button color="primary" (click)="openTestDialog()">Novo teste</button>
        </div>
      </div>
  
      <div class="list-container">
        <mat-action-list>
          <button mat-list-item *ngFor="let test of pagedTests">
            <h3 matLine (click)="openTestDialog(test)">{{ test.name }}</h3>
            <p matLine (click)="openTestDialog(test)">{{ test.description }}</p>
            <button mat-icon-button color="primary" (click)="openTestDialog(test)">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="accent" (click)="removeSelectionTest(test)">
              <mat-icon>delete</mat-icon>
            </button>
          </button>
        </mat-action-list>
  
        <div class="empty-content mt10" *ngIf="!tests || tests.length === 0">
          <span class="mat-body-2">Nenhum teste encontrado</span>
        </div>
      </div>
  
      <mat-paginator *ngIf="tests && tests.length > 0" [length]="tests.length" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  
    <div class="section">
      <div class="header">
        <span class="mat-title">Entrevistas</span>
        <div class="controls">
            <button mat-raised-button color="primary" (click)="newInterview()">Nova Entrevista</button>
        </div>
      </div>
      <div class="list-container">
        <mat-action-list>
            <button mat-list-item *ngFor="let item of pagedInterviews" (click)="openSelectionInterview($event,item)">
                <h3 matLine>{{ item.name }}</h3>                    
                <p matLine>
                    {{ item.date_start | date: 'dd/MM/yyyy' }} as {{ formatTime(item.time_start) }}
                    <ng-container *ngIf="item.time_end">
                        até {{formatTime(item.time_end)}}
                    </ng-container>
                </p>
                <p matLine style="margin-bottom: 0;"> Tipo: {{ item.type === 'true' ? 'Entrevista Remota' : 'Entrevista Presencial' }}</p>
                <span matLine *ngIf="item.type === 'false'">{{ item.address }}</span>
                <span matLine>Falar com {{ item.contact }}</span>
                
                <button color="primary" mat-icon-button matTooltip="Agendar entrevista"
                    (click)="openInterviewSession($event, item)">
                    <mat-icon>event</mat-icon>
                </button>

                <button mat-icon-button color="primary" (click)="openSelectionInterview($event, item)">
                  <mat-icon>edit</mat-icon>
                </button>

                <button color="warn" mat-icon-button *ngIf="item.status === 'read'"
                    (click)="deleteInterview($event, item)">
                    <mat-icon>delete</mat-icon>
                </button>
            </button>
        </mat-action-list>

        <div class="empty-content mt10" *ngIf="interviews.length === 0">
          <span class="mat-body-2">Nenhuma entrevista encontrada</span>
        </div>
      </div>
      <mat-paginator *ngIf="interviews.length > 0" [length]="interviews.length" [pageSize]="interviewsPageSize" [pageSizeOptions]="[5, 10, 20]" (page)="onInterviewsPageChange($event)">
    </mat-paginator>
    </div>
</div>
  